@use '@helsenorge/designsystem-react/scss/spacers' as spacers;

.feedbackpanelcontainer {
  display: flex;
  flex-direction: column;
  gap: spacers.getSpacer(m);
  padding-top: spacers.getSpacer(s);
  padding-bottom: spacers.getSpacer(s);
}

.disclaimertext {
  margin: 0;
}
